import { Divider, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { CartProductCode } from '@ace-clublabs/common-membership-api-types';
import { ReviewItem } from './ReviewItem';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { ProductType } from '../../application/models/NewJoinSessionData';

export const OneTimeItemsSection = () => {
  const { sessionData } = useContext(MembershipAppStateContext);
  const admissionFeeCost = sessionData?.priceCart?.items?.find((item) => item.code === CartProductCode.ADMISSION);
  const hasERS = sessionData.formData?.products?.includes(ProductType.ERS);
  const autopayDiscount = sessionData?.priceCart?.items?.find((item) => item.code === CartProductCode.AUTOPAY_DISCOUNT);
  const autoPayDiscountAmount = autopayDiscount && autopayDiscount.price;

  return (
    <Stack>
      <Stack direction="column" className="one-time-items-section" width="100%" gap="0.5rem">
        <Typography variant="b3Regular" className="one-time-items-title">
          One-time charges & savings
        </Typography>
        <ReviewItem className="admission-fee" title="New member admission fee" {...admissionFeeCost!} />

        {/* ERS item */}
        {hasERS &&
          (() => {
            const productPriceCart = sessionData.priceCart?.items?.find((a) => a.code === CartProductCode.ERSFEE);
            return <ReviewItem title={productPriceCart?.description!} {...productPriceCart!} className="ers" />;
          })()}

        {/* Autopay discount item */}
        {autopayDiscount && (
          <ReviewItem
            title="Auto Pay savings"
            id="autopay"
            code={CartProductCode.AUTOPAY_DISCOUNT}
            price={0}
            discount={autoPayDiscountAmount}
            discountedPrice={-autoPayDiscountAmount!}
            description="One-time Auto Pay discount"
          />
        )}
      </Stack>
      <Divider variant="fullWidth" sx={{ margin: '1rem 0' }} />
    </Stack>
  );
};
